import { getSubjects } from '@school_ify/schoolify-repository/src/shared/repositories/subjectRepository';
import { SubjectsQuery } from '@school_ify/schoolify-repository/src/shared/types';

class HeaderServices {
  public async getHeaderClasses(): Promise<SubjectsQuery> {
    try {
      const subjectsData = await getSubjects();
      return subjectsData;
    } catch (err) {
      return err;
    }
  }
}

export default new HeaderServices();
